import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 50vh;

  opacity: 0.5;
`

export const Logo = styled.img`
  margin-bottom: 1rem;
`
